import { FunctionComponent, ReactNode } from 'react';
import { Canvas } from '@react-three/fiber';
import { NoToneMapping, sRGBEncoding } from 'three';
import { bgBlack } from '@/lib/colors';
import { useDprContext } from '@/context/DprContext';

export const ThreeCanvas: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
    const { dpr } = useDprContext();
    return (
        <Canvas
            gl={{
                autoClear: true,
                physicallyCorrectLights: true,
                powerPreference: 'high-performance',
                outputEncoding: sRGBEncoding,
                antialias: false,
                depth: false,
                stencil: false,
                toneMapping: NoToneMapping,
            }}
            style={{ background: bgBlack }}
            dpr={dpr}
            flat={true}
        >
            {children}
        </Canvas>
    );
};
